<template>
  <common-template>
      <div class="list">
        <h1 class="title d-flex border-bottom inner">{{ $t(pageTitle) }}</h1>
        <div class="inner d-flex justify-content-end mt-4 mb-4">
          <button
            @click="editLink()"
            type="button"
            class="btn btn-success create-btn"
          >{{ $t("登録") }}</button>
        </div>
        <div class="table-list inner">
          <h2 class="title">{{ $t("取込設定") }}</h2>
          <div class="content">
            <table class="table table-bordered">
              <tbody class="tbody">
                <template v-if="!load && mixinGetItems.length">
                  <tr v-for="(item, index) in mixinGetItems" :key="index">
                    <td>{{ item.name }}</td>
                    <td width="130">
                      <button
                        type="button"
                        class="btn-light btn"
                        @click="editLink(item)"
                      >{{ $t("編集") }}</button>
                    </td>
                    <td width="130">
                      <button
                        type="button"
                        class="btn-danger btn"
                        @click="deleteAlert(item)"
                      >{{ $t("削除") }}</button>
                    </td>
                  </tr>
                </template>
                <template v-else-if="!load && !mixinGetItems.length">
                  <tr>
                    <td rowspan="2" colspan="99" class="text-center">
                      {{ $t("ノーデータメッセージ") }}
                    </td>
                  </tr>
                </template>
                <template v-else-if="load">
                  <tr>
                    <td colspan="12">
                      <div class="d-flex justify-content-center m-5" v-if="load">
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <paginate
          :page-count="mixinGetPageCount"
          :force-page="mixinGetForcePage"
          :page-range="3"
          :margin-pages="1"
          :click-handler="mixinClickCallback"
          :prev-text="'«'"
          :next-text="'»'"
          :container-class="'pagination justify-content-end'"
          :page-class="'page-item'"
          :page-link-class="'page-link'"
          :prev-class="'page-item'"
          :prev-link-class="'page-link'"
          :next-class="'page-item'"
          :next-link-class="'page-link'"
          ref="page"
        ></paginate>
      </div>
  </common-template>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      list: [],
      load: false,
      pageTitle: '製品工程データ取込設定一覧',
    }
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  async created() {
    this.load = true
    try {
      await this.$store.dispatch('auth/user')
    } catch (err) {
      this.$toasted.show(this.$t('データ取得エラーメッセージ'))
    }
    await this.getSetting()
    this.load = false
  },
  methods: {
    async getSetting() {
      this.load = true
      try {
        this.list = []
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/import/settings`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: {
              type: 'productProcess',
            },
          }
        )
        this.list = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
      this.load = false
    },
    async deleteAlert(item) {
      const confirm = await this.$swal({
        text: this.$t(`${item.name}`) + this.$t('削除確認メッセージ'),
        className: 'swal-none',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            value: true,
            visible: true,
            className: '',
            closeModal: false,
          },
        },
        dangerMode: true,
      })
      if (confirm) {
        try {
          await this.$axios.put(
            `${this.$appConfig.CommonApiUrl}/import/setting`,
            { id: item.id, type: 'productProcess', isDelete: true },
            {
              headers: {
                Authorization: this.authorization ? this.authorization : null,
              },
            }
          )
          this.$swal.close()
          this.$toasted.success(this.$t('データ削除完了メッセージ'))
          this.getSetting()
        } catch (err) {
          this.$toasted.show(this.$t('データ削除エラーメッセージ'))
        }
      }
    },
    editLink(item) {
      let params = {}
      if (item)params.id = item.id
      let paramString = ''
      if (this.mixinGetUrlParams(params)) {
        paramString = `?${this.mixinGetUrlParams(params)}`
      }
      const url = '/product-process-import/edit.html'

      window.location.href = process.env.NODE_ENV !== 'development' ? `/base${url}${paramString}` : url + paramString
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
  },
}
</script>

<style lang="scss" scoped>
</style>
